"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
exports.handleEditableClassName = function (classNamesOptions, additionalClassName, overrideDefaultClassName) {
    if (additionalClassName === void 0) { additionalClassName = ""; }
    if (overrideDefaultClassName === void 0) { overrideDefaultClassName = ""; }
    if (overrideDefaultClassName !== "" && typeof overrideDefaultClassName === "string") {
        return overrideDefaultClassName;
    }
    if (additionalClassName !== "" && typeof additionalClassName == "string") {
        classNamesOptions[additionalClassName] = true;
    }
    return classnames_1.default(classNamesOptions);
};
exports.includeActiveLoadingMaskClass = function (className, active, loadingClass) {
    var _a;
    if (loadingClass === void 0) { loadingClass = "loading-whirl"; }
    return classnames_1.default((_a = {},
        _a[className] = typeof className === "string",
        _a[loadingClass] = active,
        _a));
};
